import React from 'react';
// The rules and privacy pages' long-read layout: a page somebody reads rather than acts on.
import '../features/rules/rules.css';

/**
 * Where every advert leads: how to sponsor a game or a league (lmsbe backlog item 52).
 *
 * It promises only what can be delivered by hand today - a sponsor's logo in the advert
 * spaces on one game's or league's screens - because nothing in the platform does sponsorship
 * yet. A new promise here is a feature somebody then has to build, so add one when it exists.
 *
 * Signed in only, like the adverts that link here.
 */
const CONTACT_EMAIL = 'help@gafferpicks.com';
const SUBJECT = 'Sponsoring a game or league';

function Section({ id, title, children }) {
  return (
    <section className="rp-section" id={id} aria-labelledby={`${id}-heading`}>
      <h2 className="rp-h2" id={`${id}-heading`}>{title}</h2>
      {children}
    </section>
  );
}

function SponsorPage() {
  return (
    <div className="page-container fade-in">
      <div className="rp">
        <header className="rp-hero">
          <span className="rp-eyebrow">Sponsorship</span>
          <h1 className="rp-title">Put your name on a game or a league.</h1>
          <p className="rp-lede">
            Every week the players in a game come back to make their pick, check the round and
            give each other stick on the Banterboard. Your name can be there when they do.
          </p>
        </header>

        <Section id="what" title="What you get">
          <ul className="rp-list">
            <li>Your logo in the advert spaces on that game's or league's screens, seen by
              its players every week of the season.</li>
            <li>A link from your advert to wherever you want to send people.</li>
          </ul>
        </Section>

        <Section id="who" title="Who it suits">
          <p className="rp-body">
            The local pub that hosts the group, the five-a-side club, the business the league
            was started at, or anybody who would like a room full of football fans to know
            their name.
          </p>
        </Section>

        <Section id="contact" title="Get in touch">
          <p className="rp-body">
            Email{' '}
            <a href={`mailto:${CONTACT_EMAIL}?subject=${encodeURIComponent(SUBJECT)}`}>{CONTACT_EMAIL}</a>
            {' '}with the name of the game or league you would like to sponsor, and we will
            come back to you.
          </p>
        </Section>

        <p className="rp-body rp-body-quiet">
          The adverts you see on the site today are our own jokes - made-up brands, not real
          companies, and none of them has paid to be there.
        </p>
      </div>
    </div>
  );
}

export default SponsorPage;
